export enum PaymentFrequency {
  Annually = 1,
  Monthly = 2,
}
